<template>
  <div :class="[isSelected ?'card selected ':'card']" :style="{width:imageSize,height:imageSize}">
    <div
      class="card_bg"
      :class="{ blur: isBlurBackground }"
      :style="{ backgroundImage: `url(${cardInfo.Icon})` }"
      @click.stop="clickCard(cardInfo)"
    />
    <img :src="cardInfo.Icon" class="card_img">
    <div class="card_title" :title="cardInfo.Name">
      {{ cardInfo.Name }}
      <i
        v-if="canEditLight"
        class="el-icon-edit edit"
        @click.stop="showLightDialog($event)"
      />
    </div>
    <div class="video_playing" @click="changePlayer">
      <!-- <div>{{ statusText }}</div>
      <img :src="statusIcon" alt=""> -->
    </div>
    <div class="video_tip">
      {{ getStatusDisplay(cardInfo) }}
    </div>
    <div v-if="cardInfo.SceneStatus === PLANSTATUS.UpLoading" class="upload-time-estimate">
      {{ $t('tianmu.estimate') }}: {{ formatTime(cardInfo.uploadEstimateTime) }}
    </div>
    <div v-if="cardInfo.SceneStatus === PLANSTATUS.Configing" class="upload-time-estimate">
      {{ $t('tianmu.estimate') }}: 3{{ $t('tianmu.minutes') }}
    </div>
    <div v-if="cardInfo.SceneStatus === PLANSTATUS.Upload_Failed || cardInfo.SceneStatus === PLANSTATUS.TranscodeFailed" class="retry">
      {{ $t('tianmu.clickToRetry') }}
    </div>
    <el-checkbox
      v-if="isEdit"
      :value="cardInfo.ischecked"
      class="card_check"
      @change="val => changeCheck(cardIndex, val)"
      @click.native.stop
    />
    <img
      :src="cardInfo.icon_status"
      class="icon_status"
      @click.stop="clickCard(cardInfo)"
    >
    <!-- 视频播放能力 -->
    <div class="video_action">
      <slot name="action" />
    </div>
    <div v-if="canEditLight && isShowEdit" class="light-edit-dialog" :style="lightEditStyle">
      <div class="main">
        <span class="inputTitle">{{ $t('devicecard.light') + '：' }}</span>
        <div class="light">
          <!-- <OppleTriggerUiCom type="UIControl_Bright" :component-props="{ DefaultValue: 100, Desc: '亮度', }" /> -->
          <UIControl_Bright
            :name="$t('devicecard.light')"
            :value="lightValue"
            :min="1"
            :max="100"
            type="SliderWithInput"
            @change="(value) => {
              lightValue = value
            }"
          />
        </div>
      </div>
      <div class="light-edit-btnList">
        <OppleButton
          type="default"
          size="mini"
          @click.native.stop="isShowEdit = false"
        >
          {{ $t('visual.cancel') }}
        </OppleButton>
        <OppleButton
          size="mini"
          @click.native.stop="handlerEditScene"
        >
          {{ $t('deviceMsg.sure') }}
        </OppleButton>
      </div>
    </div>
  </div>
  <!-- <div class="video_tip">
      {{ getStatusDisplay(cardInfo.SceneStatus) }}
    </div>
    <div v-if="cardInfo.SceneStatus === PLANSTATUS.UpLoading" class="upload-time-estimate">
      预估: {{ formatTime(cardInfo.uploadEstimateTime) }}
    </div>
    <div v-if="cardInfo.SceneStatus === PLANSTATUS.Upload_Failed || cardInfo.SceneStatus === PLANSTATUS.TranscodeFailed" class="retry">
      {{ '点击重试' }}
    </div>
    <el-checkbox
      v-if="isEdit"
      :checked="cardInfo.ischecked"
      class="card_check"
      @change="changeCheck()"
    />
    <img
      :src="STATUS_ICON[cardInfo.SceneStatus]"
      class="icon_status"
      @click.stop="clickCard()"
    >
  </div> -->
</template>

<script>
import { STATUS_PLAY_VIDEO,STATUS_PLAY_VIDEO_TXT,STATUS_PLAY_VIDEO_ICON } from '@/components/OppleDeviceTianMu/constants'
import { PLANSTATUS, STATUS_DISPLAY, STATUS_ICON, PLANTYPE } from '../constants'
import { APP_SHOW_MODE_ENUM } from '@/utils/enums'
import UIControl_Bright from '@/components/button/SliderWithInput.vue'
import OppleButton from '@/components/Base/OppleButton/index.vue'
import {
  FindDevice
} from '@/axios/IDevice.js'
import { FindScene } from '@/axios/IScene.js';
import { transLightToProp, transLightToValue } from '@/utils/actionsHandler';

export default {
  name: 'StatusCard',
  components: {
    UIControl_Bright,
    OppleButton
  },
  props:{
    cardInfo:{
      type:Object,
      default:()=>{},
    },
    cardIndex:{
      type:Number,
      default:0
    },
    isEdit:{
      type:Boolean,
      default:false
    },
    ischecked:{
      type:Boolean,
      default:false
    },
    isSelected:{
      type:Boolean,
      default:false
    },
    showMode: {
      type: Number,
      default: 0,
    },
    isEditVideoScene: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isShowEdit: false,
      PLANSTATUS,
      STATUS_ICON,
      STATUS_PLAY_VIDEO,
      currentStatus: 0, // 初始为停止状态
      APP_SHOW_MODE_ENUM,
      lightValue: 100,
      lightEditStyle: null,
    };
  },
  computed:{
    isBlurBackground() {
      const status = this.cardInfo.SceneStatus;
      const {
        UpLoading,
        Configing,
        Upload_Failed,
        TranscodeFailed,
        NotSupportedVideo,
        Transcoding,
        Deploy_Failed,
        Overflow
      } = PLANSTATUS;

      // 需要模糊的状态
      return [
        UpLoading,
        Configing,
        Upload_Failed,
        TranscodeFailed,
        NotSupportedVideo,
        Transcoding,
        Deploy_Failed,
        Overflow
      ].includes(status);
    },
    // 计算属性：当前状态文本
    statusText() {
      // const statusTexts = {
      //   [this.STATUS_PLAY_VIDEO.Playing]: '播放中',
      //   [this.STATUS_PLAY_VIDEO.Pause]: '已暂停',
      //   [this.STATUS_PLAY_VIDEO.Stoped]: '已停止',
      // };
      return STATUS_PLAY_VIDEO_TXT[this.currentStatus];
    },
    // 计算属性：当前状态图标
    statusIcon() {
      // const statusIcons = {
      //   [this.STATUS_PLAY_VIDEO.Playing]: 'fa-pause',
      //   [this.STATUS_PLAY_VIDEO.Pause]: 'fa-play',
      //   [this.STATUS_PLAY_VIDEO.Stoped]: 'fa-play',
      // };
      return STATUS_PLAY_VIDEO_ICON[this.currentStatus] || 'fa-question';
    },
    imageSize(){
      return this.showMode === APP_SHOW_MODE_ENUM.IFTTT?'100px':'180px'
    },
    canEditLight() {
      return this.isEditVideoScene && this.cardInfo.SceneStatus === PLANSTATUS.AllSuccess
    }
  },
  methods: {
    // 公共工具方法
    formatTime(time) {
      const minutes = Math.floor(time / 60)
      const seconds = Math.floor(time % 60)
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
    },
    getStatusDisplay(cardInfo) {
      const status = cardInfo.SceneStatus
      const SceneId = cardInfo.SceneId
       //转码成功不提示文案，直接就是待下发
      if(status === PLANSTATUS.TranscodeCompleted) {
        return;
      }

      // if(SceneId === 0 && status === 0) return;
      return STATUS_DISPLAY[status]
    },
     // 切换播放/暂停状态
    changePlayer() {
      if (this.currentStatus === STATUS_PLAY_VIDEO.Playing) {
        // 当前正在播放，切换到暂停
        this.currentStatus = STATUS_PLAY_VIDEO.Pause;
      } else {
        // 当前暂停或停止，切换到播放
        this.currentStatus = STATUS_PLAY_VIDEO.Playing;
      }

      this.$emit('changePlayer',{cardIndex:this.cardIndex,currentStatus:this.currentStatus})
    },
    clickCard(info){
      this.$emit('clickCard',info)
    },
    changeCheck(){
      this.$emit('changeCheck',this.cardIndex)
    },

    handlerEditScene() {
      const lightValue = transLightToValue(this.lightValue);

      this.isShowEdit = false;
      this.$emit('handlerEditScene',lightValue);
    },

    async getCurrentLight() {
      try {
        const res = await FindScene({
          sceneNo: this.cardInfo.SceneId
        });

        const firstDevice = (res.Result?.DeviceList || [])[0] || {};
        const ActionList = firstDevice.ActionList || [];
        const firstValues = (ActionList[0] || {}).Values || [];
        const lightInfo = firstValues.find(item => item.KeyId === 3) || {};

        return {
          min: 0,
          max: 100,
          value: Math.min(255, Number(lightInfo.Value)) || 255
        };
      } catch (error) {
        return {
          min: 0,
          max: 255,
          value: 255
        };
      }
    },

    async showLightDialog(event) {
      if (!this.canEditLight) return;
      if (this.isShowEdit === false) {
        // await 前缓存卡片 DOM，避免事件目标失效
        const card = event?.currentTarget?.closest?.('.card') || this.$el;
        const lightInfo =  await this.getCurrentLight();

        this.lightValue = transLightToProp(lightInfo.value);
        this.lightEditStyle = this.calcLightEditStyle(card);
        this.$emit('closeOthers')
      }

      this.isShowEdit = !this.isShowEdit;
    },

    calcLightEditStyle(card) {
      if (!card) return { left: '0', right: 'auto' };

      const dialogWidth = 400;
      const cardRect = card.getBoundingClientRect();
      const boundaryEl =
        card.closest('.el-dialog') ||
        card.closest('.el-scrollbar__wrap') ||
        card.closest('.have_tree') ||
        document.documentElement;
      const boundaryRight = Math.min(
        boundaryEl.getBoundingClientRect().right,
        window.innerWidth
      );
      // 左对齐会超出容器时改为右对齐（预留边距，避免贴边裁切）
      const overflowRight = cardRect.left + dialogWidth > boundaryRight - 24;

      return overflowRight
        ? { left: 'auto', right: '0' }
        : { left: '0', right: 'auto' };
    },
  },
};
</script>

<style lang="scss" scoped>
.light-edit-dialog {
  position: absolute;
  width: 400px;
  height: 120px;
  background-color: #fff;
  bottom: -120px;
  left: 0;
  z-index: 9999;
  box-shadow: 3px 5px 25px 0px rgba(64, 64, 64, 0.22);
  border-radius: 4px;

  .main {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
    .light {
      width: 300px;
    }
  }

  .light-edit-btnList {
    display: flex;
    justify-content: center;
    align-items: center;

    &>:first-child {
      margin-right: 8px;
    }
  }
}

.card_container {
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      .video_tip {
        position: absolute;
        left: 50%;
        top: 50%;
        color: #fff;
        transform: translateX(-50%);
      }
      .retry {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 60%;
        color: #fff;
      }
      .upload-time-estimate {
        position: absolute;
        left: 50%;
        top: 60%;
        color: #fff;
        transform: translateX(-50%);
      }
    }
   .card {
      width: 189px;
      height: 189px;
      border-radius: 5px;
      position: relative;
      margin-right: 15px;
      margin-bottom: 15px;
      cursor: pointer;
     .card_bg {
        position: absolute;
        inset: 0;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        border-radius: 5px;
        z-index: 0;
        will-change: transform, filter;
        &.blur {
          filter: blur(8px) saturate(1.05);
        }
      }
      &.selected {
        outline: 6px solid #409EFF;
        outline-offset: -3px; // 把描边往内收，不影响外部布局
        box-shadow: 0 0 6px rgba(64, 158, 255, 0.6);
        .video_playing{
          display: flex;
          position: absolute;
          right: 5px;
          top: 5px;
          color:#fff;
          img{
            width: 20px;
            height: 20px;
          }
        }
      }

      .card_img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        cursor: pointer;
        border-radius: 6px;
      }

      .card_title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: absolute;
        bottom: 0px;
        left: 0px;
        right: 0px;
        height: 30px;
        background-color: rgba(0, 0, 0, 0.4);
        line-height: 30px;
        color: #ffffff;
        padding: 0px 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        border-radius: 0 0 6px 6px;

        .edit {
          display: block;
          width: 18px;
          height: 18px;
          border-radius: 4px;
          color: #0211fd;
          text-align: center;
          line-height: 18px;
          background-color: #fff;
        }
      }

      .card_check {
        position: absolute;
        top: 5px;
        right: 5px;
      }

      .icon_status {
        width: 34px;
        height: 34px;
        position: absolute;
        left: 73px;
        top: 58px;
      }
    }
</style>
